export default __webpack_public_path__ + "static/media/womens-fashion.3663963e.jpg";